import { Link, Text, useDisclosure } from '@chakra-ui/react';
import { InteractiveTooltip } from 'app/components/Core/InteractiveTooltip';
import { useIsMobile } from 'app/utils/hooks';

export const StorageTooltip = () => {
  const { onClose, onOpen, isOpen } = useDisclosure();
  const isMobileView = useIsMobile(false);
  const placement = isMobileView ? 'bottom' : 'right';

  return (
    <InteractiveTooltip
      iconWidth={3.5}
      popoverProps={{
        placement,
        onClose,
        onOpen,
        isOpen,
      }}
    >
      <Text color="white">
        Your storage is made up of the total audio uploaded by both you and any
        collaborators on your shared songs.
      </Text>
      <Link
        onClick={onClose}
        color="B.80"
        fontSize="xs"
        textDecoration="none"
        fontWeight={500}
        mt={2}
        href="https://support.sessionstudio.com/en/articles/7059757-subscriptions"
        target="_blank"
      >
        LEARN MORE
      </Link>
    </InteractiveTooltip>
  );
};
